import { Status } from 'components';
import { helper, types } from 'utils';

export const Payments = {
	heading: [
		'Token',
		'Amount',
		'Description',
		'User',
		'Status',
		'Gateway',
		'Date',
	],
	data: (data) =>
		data.map((row) => {
			return {
				token: (
					<Status
						status={row.status}
						label={row.token}
						dot={false}
						onClick={() => helper.copyToClipboard(row.token)}
					/>
				),
				amount: <b>{helper.format.currency(row.amount)}</b>,
				description: row.description,
				user: (
					<div>
						<div>
							<b>Name:</b> {row.user.name}
						</div>
						<div>
							<b>Phone:</b> {helper.format.phoneNumber(row.user.phoneNumber)}
						</div>
						<div>
							<b>Email:</b> {row.user.email || 'N/A'}
						</div>
					</div>
				),
				status: (
					<Status
						status={row.status}
						label={types.PaymentStatusLabels[row.status]}
					/>
				),
				gateway: helper.ucWords(row.gateway),
				date: helper.format.date(row.createdAt),
			};
		}),
};

export const VoucherLogs = {
	heading: ['Order ID', 'User', 'Discount', 'Status', 'Date'],
	data: (data) =>
		data.map((row) => {
			const user = row?.order?.user || row?.user;
			const order = row?.order;
			return {
				orderId: order && (
					<div
						className="copy"
						onClick={() => helper.copyToClipboard(row.order.id)}
					>
						<Status
							status={types.OrderStatusColors[row.order.status]}
							label={`#${row.order.id}`}
							dot={false}
						/>
					</div>
				),
				user: (
					<div>
						<div className="font-weight-bold">{user.name || 'N/A'}</div>
						{user.email && (
							<div
								className="copy"
								onClick={() => helper.copyToClipboard(user.email)}
							>
								{user.email}
							</div>
						)}
						{user.phoneNumber && (
							<div>{helper.format.phoneNumber(user.phoneNumber)}</div>
						)}
					</div>
				),
				discount: order && (
					<div>
						<div>
							Meal: <b>₦{helper.numberFormat(order.amount?.amount, 2)}</b>
						</div>
						<div className="primary">
							Discount:{' '}
							<b>- ₦{helper.numberFormat(order.amount?.discount, 2)}</b>
						</div>
					</div>
				),
				status: (
					<Status
						status={row.status === 'FAILED' ? 2 : 1}
						label={`${row.status === 'FAILED' ? row.details : `Success`}`}
					/>
				),
				date: helper.format.date(row.createdAt),
			};
		}),
};

export const PromotionLogs = {
	heading: ['Order ID', 'User', 'Discount', 'Status', 'Date'],
	data: (data) =>
		data.map((row) => {
			const user = row?.order?.user || row?.user;
			const order = row?.order;
			return {
				orderId: order && (
					<div className="copys">
						<Status
							status={types.OrderStatusColors[order.status]}
							label={`#${order.id}`}
							dot={false}
							onClick={() => helper.copyToClipboard(order.id)}
						/>
					</div>
				),
				user: (
					<div>
						<div className="font-weight-bold">{user?.name || 'N/A'}</div>
						{user?.email && (
							<div
								className="copy"
								onClick={() => helper.copyToClipboard(user?.email)}
							>
								{user?.email}
							</div>
						)}
						{user?.phoneNumber && (
							<div>{helper.format.phoneNumber(user?.phoneNumber)}</div>
						)}
					</div>
				),
				discount: order && (
					<div>
						<div>
							Meal: <b>₦{helper.numberFormat(order.amount?.amount, 2)}</b>
						</div>
						<div className="primary">
							Discount:{' '}
							<b>- ₦{helper.numberFormat(order.amount?.discount, 2)}</b>
						</div>
					</div>
				),
				status: order && (
					<Status
						status={types.OrderStatusColors[order.status]}
						label={order.status}
					/>
				),
				date: helper.format.date(order.createdAt),
			};
		}),
};
